import { render, staticRenderFns } from "./OurProjects.vue?vue&type=template&id=586d7ad6&scoped=true&"
import script from "./OurProjects.vue?vue&type=script&lang=js&"
export * from "./OurProjects.vue?vue&type=script&lang=js&"
import style0 from "./OurProjects.vue?vue&type=style&index=0&id=586d7ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d7ad6",
  null
  
)

export default component.exports